import React from 'react';
import { ErrorBoundary, Props } from '@datadog/browser-rum-react';
import { ErrorWithContext } from '@fabric-ui/utils';
import { ErrorLoadingWidget } from '../../../../components/Widgets/layout.components';
import type { WidgetProps } from './Widget';
import { isWidgetError, WidgetError } from './WidgetError';

type WidgetErrorBoundaryContext = {
  data: unknown;
  responseTotals: unknown;
} & Pick<WidgetProps, 'globalFilters' | 'widget' | 'selected' | 'isEdit' | 'visible'>;

// eslint-disable-next-line fabric-ui/no-class
class WidgetErrorBoundaryImpl extends ErrorBoundary {
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    // eslint-disable-next-line fabric-ui/no-let
    let err = error;
    if (!isWidgetError(error)) {
      err = new WidgetError(error.message, {
        context: {
          // @ts-expect-error: context is not part of the Props type but is used in the constructor
          ...this.props.context,
          ...ErrorWithContext.extractContext(error),
        },
        cause: error,
      });
    }
    super.componentDidCatch?.(err, errorInfo);
  }
}

const RenderFallback: Props['fallback'] = () => <ErrorLoadingWidget text="Error loading the widget" />;
export const WidgetErrorBoundary = ({ children, context }: React.PropsWithChildren<{ context: WidgetErrorBoundaryContext }>) => (
  <WidgetErrorBoundaryImpl
    fallback={RenderFallback}
    // @ts-expect-error: context is not part of the Props type but is used in the constructor
    context={context}>
    {children}
  </WidgetErrorBoundaryImpl>
);
